import SsrEditor from '../../server/SsrEditor';
const getEditor = (editor)=>{
    if (!editor) {
        return SsrEditor;
    }
    return editor;
};
export const isExtensionInstalled = (editor, name)=>{
    var _editor_storage_daextconfig;
    const conf = (_editor_storage_daextconfig = editor.storage['da-ext-config']) !== null && _editor_storage_daextconfig !== void 0 ? _editor_storage_daextconfig : {};
    return conf[name] !== false;
};
export const getCurrentUser = (editor)=>{
    return editor.storage['da-currentUser'];
};
export const getExtensionOptions = (editor, name)=>{
    const extension = editor.extensionManager.extensions.find((ext)=>ext.name === name);
    return extension === null || extension === void 0 ? void 0 : extension.options;
};
export const getExternalRenderer = (editor, key)=>{
    var _getEditor_storage_daextrenderers;
    const renderers = (_getEditor_storage_daextrenderers = getEditor(editor).storage['da-ext-renderers']) !== null && _getEditor_storage_daextrenderers !== void 0 ? _getEditor_storage_daextrenderers : {};
    return renderers[key];
};
export const getStoredCallback = (editor, key)=>{
    const callbacks = editor.storage['da-callbacks'];
    if (callbacks && callbacks[key]) {
        return callbacks[key];
    }
    return undefined;
};
export const getPresetId = (editor)=>{
    return editor.storage['da-presetId'];
};
export const isPapiEditorText = (value)=>{
    return (value === null || value === void 0 ? void 0 : value.excerpt) !== undefined;
};
export const isEditorState = (value)=>{
    return (value === null || value === void 0 ? void 0 : value.version) !== undefined;
};
export const isJsonString = (value)=>{
    return typeof value === 'string' && value.trim()[0] === '{';
};
export const isWriterContent = (value)=>{
    if (isPapiEditorText(value)) {
        return value.html.type === 'writer';
    }
    return false;
};
/**
 * Content can be in a few formats, this figures out what things are
 * and returns the EditorState
 */ export const getContentFromStorage = (data)=>{
    // Nothing stays as nothing
    if (!data) {
        return undefined;
    }
    // Server struct parse the markup
    if (isPapiEditorText(data)) {
        if (!data.html.markup) {
            return undefined;
        }
        if (data.html.type === 'writer') {
            return data.html.markup;
        }
        return JSON.parse(`${data.html.markup}`).document;
    }
    // Editor save state object return the document
    if (isEditorState(data)) {
        // TODO validate version
        return data.document;
    }
    // JSON string parse it
    if (isJsonString(data)) {
        return JSON.parse(data);
    }
    return data;
};
export const getNodeFromSelection = (editor)=>{
    const { state } = editor;
    const { from, to } = state.selection;
    if (from === to) {
        // No range selection, single point selection
        const node = state.doc.nodeAt(from);
        return [
            node
        ];
    }
    // Range selection
    const nodes = [];
    state.doc.nodesBetween(from, to, (node, pos)=>{
        nodes.push(node);
    });
    return nodes;
};
export const shouldBlockMenuBeOpen = (editor, typeName)=>{
    if (editor.state.selection.empty) {
        return false;
    }
    const nodes = getNodeFromSelection(editor);
    if (nodes[0] && nodes[0].type.name === 'blockquote') {
        return nodes[1].type.name === typeName;
    }
    return nodes[0].type.name === typeName;
};
export const isBlockNodeActive = (editor, blockType)=>{
    for(const key in editor.schema.nodes){
        var _editor_schema_nodes_key_spec_group;
        if (((_editor_schema_nodes_key_spec_group = editor.schema.nodes[key].spec.group) === null || _editor_schema_nodes_key_spec_group === void 0 ? void 0 : _editor_schema_nodes_key_spec_group.includes(blockType)) && editor.isActive(editor.schema.nodes[key].name)) {
            return true;
        }
    }
    return false;
};
export const isElementGroupInSelection = (editor, group)=>{
    const { state } = editor;
    const { from, to } = state.selection;
    let isInSelection = false;
    // Iterate over the nodes in the selection range
    state.doc.nodesBetween(from, to, (node)=>{
        if (node.type.groups.includes(group)) {
            isInSelection = true;
            return false;
        }
    });
    return isInSelection;
};
export const deleteExtension = (typeName, editor, dispatch, state)=>{
    if (dispatch) {
        const { selection } = state;
        const node = selection.node;
        if (!node) {
            const nodes = getNodeFromSelection(editor);
            const isDev = nodes.some((n)=>n.type.name === typeName);
            if (isDev) {
                const { tr } = state;
                tr.deleteRange(selection.from, selection.to);
                dispatch(tr);
            }
        }
        if (node) {
            const { tr } = state;
            tr.deleteRange(selection.from, selection.to);
            dispatch(tr);
        }
        return true;
    }
    return true;
};
export const selectionHasLinkMark = (editor)=>{
    const { state } = editor;
    const { from, to } = state.selection;
    let hasLinkMark = false;
    state.doc.nodesBetween(from, to, (node)=>{
        if (node.marks.some((mark)=>mark.type.name === 'link')) {
            hasLinkMark = true;
        }
    });
    return hasLinkMark;
};

//# sourceMappingURL=tiptap.js.map